export const edit_pair = "edit-card-edit-entry";
export const display_pair = "edit-card-display-entry";

export const edit_singleton = "edit-entry";
export const display_singleton = "edit-display-entry";